import ArtistPage from "../pages/Artist";

const Artist = () => {
  return (
    <div className="container min-h-screen  mx-auto px-6 md:px-14  flex flex-col gap-6 items-start justify-center   ">
      <ArtistPage />
    </div>
  );
};

export default Artist;
